export const STATUS = {
  ERROR: 'error',
  PENDING: 'pending',
  FINISHED: 'finished',
  PROCESSING: 'processing',
};
